import React from 'react'
import styled from 'styled-components'
import { Draggable } from '../../shared-componenets/AtlasDragDrop/Draggable'

const Container = styled.div`
  border: 1px solid lightgrey;
  border-radius: 2px;
  padding: 8px;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;
  background-color: ${props =>
        props.isDragDisabled
            ? 'lightgrey'
            : props.isDragging
                ? 'silver'
                : 'white'};
`

export default class Task extends React.Component {
    render() {
        return (
            <Draggable
                draggableId={String(this.props.task.id)}
                index={this.props.index}
                isDragDisabled={this.props.isDragDisabled}
                solidDragPreview
            >
                {({ isDragging, isDragDisabled }) => (
                    <Container isDragging={isDragging} isDragDisabled={isDragDisabled}>
                        {this.props.task.content}
                    </Container>
                )}
            </Draggable>
        )
    }
}
